import SafeImage from '@ui/SafeImage';
import { AppStoreButtons } from 'app/get-the-app/components/GetTheApp';
import React from 'react';
import { StarIcon } from 'lucide-react';
import { prefix } from '@util/imagePrefix';
import HomeSection from './Home/components/HomeSection';

const GetTheAppCTA = () => {
  return (
    <HomeSection
      fullWidth
      backgroundColor="bg-black"
      className="overflow-hidden py-16"
    >
      <div className="flex w-full flex-col items-center justify-center lg:flex-row lg:justify-start">
        <div className="hidden lg:flex">
          <SafeImage
            src={`${prefix}/assets/homepage/homepage-get-the-app-cta_1920x2560.png`}
            alt="mockup"
            className="h-full w-auto pl-32"
          />
        </div>

        <div className="flex w-full justify-center pt-16 lg:hidden">
          <SafeImage
            src={`${prefix}/assets/homepage/homepage-get-the-app-cta_1920x2560.png`}
            alt="mockup"
            className="h-full w-auto"
          />
        </div>

        <div className="absolute z-10 mt-[8rem] block h-[36rem] w-[50rem] bg-gradient-to-t from-black via-transparent to-transparent lg:hidden" />

        <div className="z-20 mt-8 sm:mt-0 lg:pl-[15rem]">
          <div className="flex flex-col items-start gap-y-6 sm:gap-y-2">
            <h2 className="w-full text-[2.5rem] font-bold text-white sm:text-[3rem]">
              <span className="hidden sm:block">
                Download the MX Locker App
              </span>
              <span className="block w-full text-center sm:hidden">
                Get MX Locker App
              </span>
            </h2>

            <AppStoreButtons center={false} />

            <div className="flex items-center gap-x-6">
              <div className="flex items-center gap-x-2">
                <div className="flex items-center">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <StarIcon
                      className="h-16 w-16 fill-[#D8A100]"
                      key={index}
                    />
                  ))}
                </div>

                <span className="text-[1.8rem] font-bold text-white">4.9</span>
              </div>

              <div className="h-2 w-2 rounded-full bg-zinc-500" />

              <span className="text-[1.8rem] font-medium text-zinc-300">
                4K+ Ratings
              </span>
            </div>
          </div>
        </div>
      </div>
    </HomeSection>
  );
};

export default GetTheAppCTA;
